// Shopify images are optimized through the transform in GraphQL (https://shopify.dev/docs/api/storefront/2023-01/input-objects/ImageTransformInput)

export default ({ src }) => src;
